<template>
  <div>
    <voxy-dropdown
      :class="['availability-manager-teacher-filter', isActive && 'availability-manager-teacher-filter_active']"
      ref="dropdown"
      menu-alignment="right"
      @on-open="isOpen = true"
      @on-close="isOpen = false"
    >
      <span slot="button" class="availability-manager-teacher-filter__icon">
        <font-awesome-icon :icon="['fas', 'calendar']" />
      </span>
      <div class="availability-manager-teacher-filter__dropdown">
        <div class="availability-manager-teacher-filter">
          <ul class="availability-manager-teacher-filter__options">
            <li class="availability-manager-teacher-filter__option">
              <label>
                <input type="checkbox" v-model="model_no_availability" name="no_availability" />
                {{ availabilityFilter.no_availability.label }}
              </label>
            </li>
            <li class="availability-manager-teacher-filter__option">
              <label>
                <input type="checkbox" v-model="model_no_availability_3week" name="no_availability_3week" />
                {{ availabilityFilter.no_availability_3week.label }}
              </label>
            </li>
          </ul>
        </div>
      </div>
    </voxy-dropdown>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { VoxyDropdown } from '@voxy-team/vue-voxy';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'AvailabilityTeacherManagerFilter',

  components: {
    FontAwesomeIcon,
    VoxyDropdown,
  },

  data() {
    return {
      isOpen: false,
    };
  },

  mounted() {
    this.model_no_availability = this.key;
  },

  computed: {
    ...mapState('manageTeachers', ['availabilityFilter']),

    hasValue() {
      return this.availabilityFilter.no_availability.value || this.availabilityFilter.no_availability_3week.value;
    },

    isActive() {
      return this.isOpen || this.hasValue;
    },

    model_no_availability: {
      get() {
        return this.availabilityFilter.no_availability.value;
      },
      set(value) {
        this.applyAvailability(value);
      },
    },

    model_no_availability_3week: {
      get() {
        return this.availabilityFilter.no_availability_3week.value;
      },
      set(value) {
        this.applyAvailability3Week(value);
      },
    },
  },

  methods: {
    ...mapActions('manageTeachers', {
      applyAvailability: 'SEARCH_BY_AVAILABILITY',
      applyAvailability3Week: 'SEARCH_BY_AVAILABILITY_3_WEEK',
    }),

    close() {
      if (this.$refs.dropdown) {
        this.$refs.dropdown.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/variables';

.availability-manager-teacher-filter {
  &__icon {
    font-size: 21px;
    display: inline-flex;
    width: 1.5rem;
    justify-content: center;
    align-items: center;

    .availability-manager-teacher-filter_active & {
      color: $default-blue;
    }
  }

  &__dropdown {
    min-width: 310px;
    padding: 15px 0 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.25);
    background-color: #515151;
    border-radius: 5px;
  }

  &__options {
    max-height: 22rem;
    margin: 0;
    padding: 4px 12px;
    overflow-y: auto;
  }

  &__option {
    display: flex;
    line-height: 1.5em;
    align-items: center;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;

    &:not(:last-child) {
      margin-bottom: 13px;
    }

    input {
      font-size: 100%;
      width: 2em;
      height: auto;
      margin: 0 10px;
      padding: 0;
      color: white;
      text-align: center;
      border-bottom: 1px solid rgba(white, 0.5);
    }

    label {
      display: inline-flex;
      align-items: center;
      text-transform: none;
    }
  }
}
</style>
